<template>
  <p class="touch-none px-4 pb-2 text-center text-xs text-light-fg-muted">AI responses may contain inaccuracies. Please verify important information.</p>
</template>
